import { render, staticRenderFns } from "./VPlus.vue?vue&type=template&id=f64b1542&"
import script from "./VPlus.vue?vue&type=script&lang=js&"
export * from "./VPlus.vue?vue&type=script&lang=js&"
import style0 from "./VPlus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports